<template>
    <b-navbar id="navbar" fixed-top spaced transparent type="is-transparent">
        <template slot="brand">
            <b-navbar-item tag="router-link" :to="{ path: '/' }">
                <img id="logo-1"
                    src="../assets/uec2.png"
                    alt="UECST"
                >
                <img id="logo-2" class="hidden"
                    src="../assets/uec-black.png"
                    alt="UECST"
                >
            </b-navbar-item>
        </template>
        <template slot="end">
            <b-navbar-item href="#">
                {{$t('home')}}
            </b-navbar-item>
            <b-navbar-dropdown>
                <template slot="label">
                    {{$t('members')}}
                </template>
                <b-navbar-item href="#1y">
                    {{$t('1y')}}
                </b-navbar-item>
                <b-navbar-item href="#2y">
                    {{$t('2y')}}
                </b-navbar-item>
                <b-navbar-item href="#3y">
                    {{$t('3y')}}
                </b-navbar-item>
                <b-navbar-item href="#4y">
                    {{$t('4y')}}
                </b-navbar-item>
            </b-navbar-dropdown>
            <b-navbar-item href="#results">
                {{$t('results')}}
            </b-navbar-item>
            <b-navbar-item href="#schedule">
                {{$t('schedule')}}
            </b-navbar-item>
            <b-navbar-dropdown>
                <template slot="label">
                    <b-icon icon="translate" size="is-small"></b-icon>
                </template>
                <b-navbar-item @click="$i18n.locale = 'jp'">
                    日本語
                </b-navbar-item>
                <b-navbar-item @click="$i18n.locale = 'en'">
                    English
                </b-navbar-item>
            </b-navbar-dropdown>
            <b-navbar-item href="#contact-us">
                {{$t('contactUs')}}
            </b-navbar-item>
            
             
            
            <!-- <b-navbar-item tag="div">
                <div class="buttons">
                    <a class="button is-primary">
                        <strong>Sign up</strong>
                    </a>
                    <a class="button is-light">
                        Log in
                    </a>
                </div>
            </b-navbar-item> -->
        </template>
    </b-navbar>
</template>

<script>
export default {
  name: 'Navbar',
  props: {
    msg: String
  },
  mounted() {
        window.onscroll = function() {
            if (document.body.scrollTop > 30 || document.documentElement.scrollTop > 30) {
                document.getElementById("navbar").classList.remove("is-spaced");
                document.getElementById("navbar").classList.remove("is-transparent");
                document.getElementById("navbar").classList.add("is-white");
                document.getElementById("logo-1").classList.add("hidden");
                document.getElementById("logo-2").classList.remove("hidden");
            } else {
                document.getElementById("navbar").classList.add("is-spaced");
                document.getElementById("navbar").classList.remove("is-white");
                document.getElementById("navbar").classList.add("is-transparent");
                document.getElementById("logo-1").classList.remove("hidden");
                document.getElementById("logo-2").classList.add("hidden");
            }
        };
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hidden {
    display: none;
}

.is-white {
    padding-left: 50px;
    padding-right: 50px;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
#navbar {
    z-index: 200;
}

</style>
